import type { ChaiApi } from "@chai/api-client";
import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

import { CommandPalette } from "@/components/CommandPalette";
import { DemoFirstRunChrome, DemoTourChrome } from "@/components/demo/DemoChrome";

import type { AuthState } from "../auth";

interface RouterContext {
  auth: AuthState;
  queryClient: QueryClient;
  apiClient: ChaiApi;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      {/* Global ⌘K quick-switcher — available across Work / Plan / Manage. */}
      <CommandPalette />
      {/* Demo sessions only: the guided tour lives ABOVE the layouts so it
          survives navigating between `_app` and /manage mid-walkthrough.
          Renders nothing unless GET /me carried a `demo` block. */}
      <DemoTourChrome />
      {/* Demo sessions only: the first-run rail — the scripted 0-90s arc, also
          above the layouts because it deep-links into the deliverable and the
          composer. Renders nothing without a valid `demo_first_run` payload,
          and suppresses the tour's auto-start while it is pending. */}
      <DemoFirstRunChrome />
    </>
  );
}
